import { render, staticRenderFns } from "./patient_card_list.vue?vue&type=template&id=60cc2fb4&scoped=true"
import script from "./patient_card_list.vue?vue&type=script&lang=js"
export * from "./patient_card_list.vue?vue&type=script&lang=js"
import style0 from "./patient_card_list.vue?vue&type=style&index=0&id=60cc2fb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cc2fb4",
  null
  
)

export default component.exports